module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon8.9a259796.png";